<template>
	<div class="wrap">
		<b-card>
			<div slot="header">
				<strong>카드 순서 설정</strong>
			</div>
			<p>게임하기 카드 순서 설정</p>
			<draggable class="list-group" element="ul" v-model="list" @start="isDragging=true" @end="isDragging=false" :options="{handle: '.dragable-item'}" :move="move">
				<!--:move="onMove"-->
				<transition-group type="transition" :name="'flip-list'">
					<li :class="getClass(element)" v-for="element in list" :key="element.adType">
						<!--<i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>-->
						<div v-for="(value, lang) in element.viewInfo.cardTitle" :key="'cardTitle'+lang">
							<input v-model="element.viewInfo.cardTitle[lang]">
							({{lang}})
							<i class="fa fa-arrows-v" style="font-size: 20px;" v-if="element.adType !=='mainstream'"></i>
						</div>
						<!--<span v-else>{{element.title}}</span>-->
						<!--<strong v-if="element.fixed" class="ml-5">(조정 불가)</strong>-->
						<!--<span class="badge ml-2">{{element.orderNo}}</span>-->
						<!--<button v-show="element.status === 'none'" type="button" @click="element.status = 'editing'; element.temp = element.title">변경</button>-->
						<!--<span v-show="element.status==='editing'">-->
							<!--<button type="button" @click="saveHandling(element)" class="ml-1">저장</button>-->
							<!--<button type="button" @click="cancelHandling(element)" class="ml-1">취소</button>-->
						<!--</span>-->
					</li>
				</transition-group>
			</draggable>
			<div class="mt-3">
				<button type="button" @click="saveHandling" class="ml-1">저장</button>
				<button type="button" @click="cancelHandling" class="ml-1">취소</button>
			</div>
		</b-card>
	</div>
</template>
<script>
import draggable from 'vuedraggable'
import { MODULE_NAME as PLAYGAME_MODULE, FETCH_AD_TYPE_LIST } from '@/store/playGame/actions.type'
import { SET_AD_TYPE_LIST, RESET_ORDER } from '@/store/playGame/mutations.type'
import { mapMutations } from 'vuex'
import { $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import playGameService from '@/common/api/playGame.service'
export default {
	data () {
		return {
		  // list: [
		  //   {
			//   title: '대세게임',
			//   orderNo: 1,
			//   fixed: true,
			//   editable: true
		  // 	},
			// {
			//   title: '사전예약 영역',
			//   orderNo: 2,
			//   fixed: false,
           //    editable: true
			// },
           //  {
           //    title: '충전소',
           //    orderNo: 3,
           //    fixed: false,
           //    editable: false
           //  },
			// {
			//   title: '이모티콘 놓지지 마세요!',
			//   orderNo: 4,
			//   fixed: false,
           //    editable: true
			// },
           //  {
           //    title: '인기게임',
           //    orderNo: 5,
           //    fixed: false,
           //    editable: true
           //  }
		  // ]
		}
	},
	components: {
		draggable
	},
	mounted() {
	  this.$store.dispatch(PLAYGAME_MODULE + FETCH_AD_TYPE_LIST)
      .catch($showModalWithErrorMsg.bind(this))
	},
	computed: {
			// list2 () {
       //  return this.$store.state.playGame.menuSettingList
			// }
	  list: {
			get() {
				return this.$store.state.playGame.adTypeList;
			},
			set(value) {
				this[SET_AD_TYPE_LIST](value)
				this[RESET_ORDER]()
			}
	  }
	},
	methods: {
	  move (evt) {
	    console.log('---move related list--')
	    console.log(evt.relatedContext.list)
      console.log('---move related list--')
	    if (evt.draggedContext.element.adType === 'mainstream' || evt.relatedContext.element.adType === 'mainstream') {
	      return false
			}
		},
	  getClass (elem) {
	    if (elem.adType === 'mainstream' ) {
        return 'list-group-item ignore'
			}
      return 'list-group-item dragable-item'
		},
		// onMove ({ relatedContext, draggedContext }){
		//   const relatedElement = relatedContext.element;
		//   const draggedElement = draggedContext.element;
		//   return (
		//     (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
		//   );
		// },
		// addMenu (list){
			// list.push({
			// 	name: '',
			// 	orderNo: this.list.length + 1,
			// 	fixed: false,
			// 	editable: true
			// })
		// },
		cancelHandling () {
      this.$store.dispatch(PLAYGAME_MODULE + FETCH_AD_TYPE_LIST)
        .catch($showModalWithErrorMsg.bind(this))
		},
		saveHandling () {
		  playGameService.saveAdTypeList({list: this.list})
        .then((res) => {
          this[SHOW_MODAL]({msg: '수정이 완료되었습니다.', okHandling: () => {}})
        })
				.catch($showModalWithErrorMsg.bind(this))
		},
		...mapMutations(PLAYGAME_MODULE, [SET_AD_TYPE_LIST, RESET_ORDER]),
    ...mapMutations('ui', [SHOW_MODAL])
	}
}
</script>
<style scoped>
	.flip-list-move {
		transition: transform 0.5s;
	}

	.no-move {
		transition: transform 0s;
	}

	.ghost {
		opacity: 0.5;
		background: #c8ebfb;
	}

	.list-group {
		min-height: 20px;
	}

	.list-group-item {
		cursor: move;
	}

	.list-group-item.ignore {
		cursor: default;
	}

	.list-group-item i {
		cursor: pointer;
	}
	.badge {
		background-color: #777;
		color: #fff;
	}
</style>
